import { useState } from 'react';

import { FoodType } from '../../../../constants/foodType';
import { DatabaseFoodItem } from '../../../../interfaces/DatabaseFoodItem';
import { foodsService } from '../../../../services/foodsService';

type UseDatabaseFoodSearchReturn = {
  foods: DatabaseFoodItem[];
  isSearch: boolean;
  isLoading: boolean;
  searchFoods: (query: string) => Promise<void>;
};

export const useDatabaseFoodSearch = (
  foodType: FoodType,
): UseDatabaseFoodSearchReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const [foods, setFoods] = useState<DatabaseFoodItem[]>([]);
  const [isSearch, setIsSearch] = useState(false);

  const searchFoods = async (query: string) => {
    const trimmedQuery = query.trim();
    setIsLoading(true);

    // every request is a live third-party call that also writes to the backend cache - none while empty
    if (!trimmedQuery) {
      setFoods([]);
      setIsSearch(false);
      setIsLoading(false);
      return;
    }

    try {
      const { foods: foundFoods } = await foodsService.searchDatabaseFoods(
        foodType,
        trimmedQuery,
        { isRunGlobalSpinner: false },
      );

      // addedByUser reads as "already in my foods"; there is no server-side filter for it, and filtering
      // here is safe only because the whole result set arrives in one response
      setFoods(foundFoods.filter(({ addedByUser }) => !addedByUser));
      setIsSearch(true);
    } finally {
      setIsLoading(false);
    }
  };

  return { foods, isSearch, isLoading, searchFoods };
};
